<template>
  <div
    class="conversation-label"
    :class="{
      '-active': active,
      '-active-convo': conversation.status === 'active',
      '-converted': conversation.converted
    }"
    @click="click"
  >
    <span ref="image" class="image"></span>
    <span class="title">{{ title }}</span>

    <span class="updated">{{ fancyTime }}</span>
    <span class="name">{{ name }}</span>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    conversation: {
      type: Object,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    name() {
      return this.conversation.metadata.context.customer_name || "New user";
    },

    title() {
      return this.conversation.metadata.context.title || "Live chat";
    },

    fancyTime() {
      return moment(this.conversation.created_at, "YYYY-MM-DD HH:mm:ss").fromNow();
    }
  },
  
  mounted() {
    this.$refs.image.style.backgroundImage = `url(${this.conversation.metadata.context.image}`;
  },

  methods: {
    click() {
      this.$emit("select", this.conversation);
    },
  }
};
</script>
